<template>
  <v-container fluid class="onboarding-page">
    <div class="onboarding-page__header">
      <div>
        <h1 class="onboarding-page__title">Solicitação de abertura de conta</h1>
        <p class="onboarding-page__subtitle">
          Etapa {{ currentStepIndex + 1 }} de {{ totalSteps }}
        </p>
      </div>
    </div>

    <div class="auth-steps onboarding-page__progress" aria-hidden="true">
      <span
        v-for="(step, index) in stepOrder"
        :key="step"
        class="auth-steps__item"
        :class="{
          'auth-steps__item--active': currentStep === step,
          'auth-steps__item--done': currentStepIndex > index,
        }"
      />
    </div>

    <v-form ref="form" v-model="valid" lazy-validation class="onboarding-page__form">
      <v-window v-model="currentStep" class="mt-2">
        <v-window-item value="mainData">
          <form-section title="Dados principais" icon="mdi-account-outline" compact>
          <v-row dense>
            <v-col cols="12" md="2">
              <v-select :items="person" v-model="partner.typeCompany" label="Tipo de parceiro" :disabled="loading"
                item-text="text" item-value="value" outlined></v-select>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field :label="partner.typeCompany == 'PJ' ? 'Razão social *' : 'Nome completo *'
                " :required="true" :disabled="loading" v-model="partner.name" outlined />
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field :label="partner.typeCompany == 'PJ'
                ? 'Nome fantasia'
                : 'Como quer ser chamado'
                " :disabled="loading" v-model="partner.nickName" outlined />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field :label="partner.typeCompany == 'PJ' ? 'CNPJ *' : 'CPF * '" :disabled="loading"
                :required="true" v-model="partner.document" outlined v-mask="partner.typeCompany !== 'PJ'
                  ? '###.###.###-##'
                  : '##.###.###/####-##'
                  " />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field label="Telefone *" :disabled="loading" :required="true" v-model="partner.phone" outlined
                return-masked-value v-mask="partner.phone.length <= 14 ? '(##) ####-####' : '(##) #####-####'
                  " />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field label="Email *" :disabled="loading" :required="true" v-model="partner.email" outlined />
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete label="Categoria *" outlined v-model="partner.categoryId" :items="categories"
                :disabled="loading" item-text="name" item-value="id" />
            </v-col>
          </v-row>
          </form-section>
        </v-window-item>
        <v-window-item value="addressData">
          <form-section title="Dados de endereço" icon="mdi-map-marker-outline" compact>
          <v-row dense>
            <v-col cols="12" md="2">
              <v-text-field label="CEP *" :disabled="loading" required="true" v-model="partner.address.zipCode"
                v-mask="'#####-###'" outlined @blur="handleAddress" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field label="Logradouro *" :required="true" :disabled="loading" v-model="partner.address.street"
                outlined />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field label="Número" :disabled="loading" v-model="partner.address.addressNumber" outlined />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field label="Complemento" :disabled="loading" v-model="partner.address.complement" outlined />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field label="Bairro *" :required="true" :disabled="loading" v-model="partner.address.neighborhood"
                outlined />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field label="UF *" :required="true" :disabled="true" :readonly="true"
                v-model="partner.address.state" outlined />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field label="Cidade *" :required="true" :disabled="true" :readonly="true"
                v-model="partner.address.cityName" outlined />
            </v-col>
          </v-row>
          </form-section>
        </v-window-item>
        <v-window-item value="userData">
          <form-section title="Dados do usuário" icon="mdi-shield-account-outline" compact>
          <v-row dense>
            <v-col cols="12" md="4">
              <v-text-field outlined label="Nome completo *" required="true" v-model="partner.user.name" />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field outlined label="Email *" :disabled="loading" required="true" v-model="partner.user.email" />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field outlined label="Celular *" @input="handleMaskPhone" required="true" :disabled="loading"
                v-model="partner.user.phone" maxlength="15" />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field outlined label="CPF *" @input="formatCPF" minLength="14" maxLength="14" :rules="rules"
                :disabled="loading" required="true" v-model="partner.user.document" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field outlined label="Nome da mãe *" v-model="partner.user.motherName" required="true"
                  :disabled="loading" />
              </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined label="Data de nascimento *" v-model="partner.user.birthdate" v-mask="'##/##/####'"
                required="true" :disabled="loading" />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'"
                required="true" v-model="partner.user.password" name="input-10-2" label="Senha *"
                class="input-group--focused" @click:append="show = !show"></v-text-field>
            </v-col>
          </v-row>
          </form-section>
        </v-window-item>
      </v-window>
      <v-row class="onboarding-page__actions">
        <v-col cols="6" class="text-left">
          <v-btn v-if="currentStep !== 'mainData'" text @click="handleBack">Voltar</v-btn>
          <v-btn v-else text @click="$router.push('/login')">Cancelar</v-btn>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn v-if="currentStep !== 'userData'" dark color="primary" depressed @click="handleNext">
            Próximo
          </v-btn>
          <v-btn
            v-else
            dark
            color="primary"
            depressed
            :disabled="!handleIsFormValid()"
            :loading="loading"
            @click="handleSave"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

  </v-container>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { GetAddress } from "@/services/viaCep/GetAddress";
import { CreatePartner } from "@/services/partners/CreatePartner";
import { GetAllCategories } from "@/services/partners/GetAllCategories";

import FormSection from "@/components/ui/FormSection.vue";

import { PartnerDetailsType } from "@/types/partner/Partner";

export default defineComponent({
  components: { FormSection },

  data() {
    return {
      rules: [(v: string) => v.length >= 14 || "CPF invalído"],
      currentStep: "mainData",
      steps: {
        mainData: "Dados principais",
        addressData: "Dados de endereço",
        userData: "Dados do usuário",
      },
      stepGroup: "Dados principais",
      valid: true,
      loading: false,
      show: false,
      person: [
        {
          id: 1,
          text: "Pessoa Fisica",
          value: "PF",
        },
        {
          id: 2,
          text: "Pessoa Jurídica",
          value: "PJ",
        },
      ],

      categories: [],
      partner: {
        id: "",
        name: "",
        status: "PENDING",
        nickName: "",
        tax: 5,
        typeCompany: "PJ",
        category: {
          name: "",
          id: "",
        },
        phone: "",
        email: "",
        document: "",
        pixkey: " ",
        cnaeCode: "",
        address: {
          state: "",
          street: "",
          addressNumber: "",
          neighborhood: "",
          complement: "",
          zipCode: "",
          cityName: "",
          ibge: "",
        },
        users: [],
        user: {
          name: "",
          email: "",
          phone: "",
          document: "",
          password: "",
          nickname: "",
          birthdate: "",
          motherName: "",
          backDocumentImage: "",
          frontDocumentImage: "",
          selfImage: "",
        },
        associate: [],
        businessHours: [],
        createdAt: "",
        digitalAccountNumber: "",
        digitalAccountDocument: "",
        associates: [],
        categoryId: "",
        contractFile: "",
        registrationStatusFile: "",
        partnerConfigs: {
          id: 0,
          onlineSale: false,
          pdvSale: false,
          updatedAt: "",
          instantCashback: 0,
          greenBuy: false,
        },
        description: "",
        instagram: "",
        whatsapp: "",
      } as PartnerDetailsType,
    };
  },
  computed: {
    stepOrder(): string[] {
      return Object.keys(this.steps);
    },
    currentStepIndex(): number {
      return this.stepOrder.indexOf(this.currentStep);
    },
    totalSteps(): number {
      return this.stepOrder.length;
    },
  },
  methods: {
    handleIsFormValid() {
      return (
        this.handleIsValidMainData() &&
        this.handleIsValidAddressData() &&
        this.handleIsValidUserData()
      );
    },
    handleIsValidMainData() {
      return (
        this.partner.name.length > 0 &&
        this.partner.document.length > 0 &&
        this.partner.phone.length > 0 &&
        this.partner.email.length > 0 &&
        this.partner.categoryId != ""
      );
    },
    handleIsValidAddressData() {
      return (
        this.partner.address.zipCode.length > 0 &&
        this.partner.address.street.length > 0 &&
        this.partner.address.neighborhood.length > 0 &&
        this.partner.address.state.length > 0 &&
        this.partner.address.cityName.length > 0
      );
    },
    handleIsValidUserData() {
      return (
        this.partner.user.name.length > 0 &&
        this.partner.user.email.length > 0 &&
        this.partner.user.phone.length > 0 &&
        this.partner.user.document.length > 0 &&
        this.partner.user.password.length > 0 &&
        this.partner.user.birthdate.length > 0 &&
        this.partner.user.motherName.length > 0
      );
    },

    async handleAddress() {
      const getAddress = new GetAddress();
      const address = await getAddress.execute(this.partner.address.zipCode);
      if (address) {
        this.partner.address.street = address.logradouro || "";
        this.partner.address.neighborhood = address.bairro || "";
        this.partner.address.cityName = address.localidade || "";
        this.partner.address.state = address.uf || "";
        this.partner.address.ibge = address.ibge || "";
      }
    },
    handleSave() {
      this.loading = true;

      const createPartner = new CreatePartner();
      createPartner
        .execute(this.partner)
        .then(() => {
          this.$store.dispatch("showSnack", {
            message: "Solicitação enviada com sucesso",
            color: "green darken-1",
          });
          this.handleLogin();
        })
        .catch(() => {
          this.$store.dispatch("showSnack", {
            message: "Erro ao enviar a solicitação",
            color: "red",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    validateNumber() {
      this.partner.digitalAccountNumber =
        this.partner.digitalAccountNumber.replace(/\D/g, "");
    },

    formatZipCod: (cep: string): string => {
      return cep.replace(/(\d{5})(\d{3})/, "$1-$2");
    },
    formatDocument: (document: string): string => {
      if (document.length === 11) {
        return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
      if (document.length === 14) {
        return document.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
      return document;
    },

    async handleGetAllCategories() {
      let categories = new GetAllCategories();
      let dataCategories = await categories.execute();

      this.categories = dataCategories.data;
    },

    handleMaskPhone() {
      this.partner.user.phone = this.partner.user.phone.replace(/\D/g, "");
      this.partner.user.phone = this.partner.user.phone
        .replace(/^(\d)/, "($1")
        .replace(/^(\(\d{2})(\d)/, "$1) $2")
        .replace(/(\d{5})(\d{1,5})/, "$1-$2")
        .replace(/(-\d{4})\d+?$/, "$1");
    },
    formatCPF() {
      let cpf = this.partner.user.document.replace(/[^\d]/g, "");

      if (cpf.length > 3) {
        cpf = cpf.substring(0, 3) + "." + cpf.substring(3);
      }
      if (cpf.length > 7) {
        cpf = cpf.substring(0, 7) + "." + cpf.substring(7);
      }
      if (cpf.length > 11) {
        cpf = cpf.substring(0, 11) + "-" + cpf.substring(11, 13);
      }

      this.partner.user.document = cpf;
    },

    handleLogin() {
      this.$router.push("/login");
    },
    handleNext() {
      if (this.currentStep === "mainData") {
        if (this.handleIsValidMainData()) {
          this.currentStep = "addressData";
        } else {
          this.$store.dispatch("showSnack", {
            message: "Preencha todos os dados principais antes de continuar.",
            color: "red",
          });
        }
      } else if (this.currentStep === "addressData") {
        if (this.handleIsValidAddressData()) {
          this.currentStep = "userData";
        } else {
          this.$store.dispatch("showSnack", {
            message: "Preencha todos os dados de endereço antes de continuar.",
            color: "red",
          });
        }
      }
    },
    handleBack() {
      if (this.currentStep === "userData") {
        this.currentStep = "addressData";
      } else if (this.currentStep === "addressData") {
        this.currentStep = "mainData";
      }
    },
  },
  mounted() {
    this.handleGetAllCategories();
  },
});
</script>
<style scoped lang="scss">
@import "@/assets/scss/design-system/tokens";

.onboarding-page {
  min-height: 100vh;
  background: $br-bg;
  padding: 24px 16px 40px;
  max-width: 1080px;
  margin: 0 auto;
}

.onboarding-page__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: $br-ink-soft;
}

.onboarding-page__subtitle {
  margin: 6px 0 0;
  color: $br-muted;
  font-size: $br-font-size-md;
}

.onboarding-page__progress {
  margin: 20px 0 8px;
}

.onboarding-page__form {
  margin-top: 8px;
}

.onboarding-page__actions {
  margin-top: 8px;
}
</style>
